import { render, staticRenderFns } from "./requiredForm.vue?vue&type=template&id=313fef6e"
import script from "./requiredForm.vue?vue&type=script&lang=js"
export * from "./requiredForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports